/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import React from 'react';
import { useSelector } from 'react-redux';

import { selectDraftCatalogErrors } from '../../../store/catalog/selectors';
import { removeErrorCode } from '../helpers';

export const ImportErrors = () => {
  const { importErrors } = useSelector(selectDraftCatalogErrors);
  return (
    <>
      {importErrors?.length &&
        importErrors.map((error: any, i: number) => (
          <div className="CatalogOpenApiFileImport__error" key={i}>
            <div className="CatalogOpenApiFileImport__error-path">
              {error.path}
            </div>
            <div className="CatalogOpenApiFileImport__error-message">
              {removeErrorCode(error.message)}
            </div>
          </div>
        ))}
    </>
  );
};
